import React from 'react';
import { SortableContainer, SortableElement, SortableHandle } from 'react-sortable-hoc';

import { GripVertical } from 'lucide-react';
import { Col, Row } from 'twyne-new.ui';

export const DragHandle = SortableHandle(({ className }) => {
  return <span className={`${className || ''} cursor-move hover:twy-text-base-accent`}><GripVertical size='16' /></span>
})

export const SortableFieldsContainer = SortableContainer(({ children }) => {
  return <div>
    {children}
  </div>
})

export const SortableField = SortableElement(({ children, customDrag, removeColContainer }) => {

  return <Row style={{ zIndex: 10000 }}>
    {!customDrag && <Col size='1'><DragHandle /></Col>}
    {removeColContainer ? children : <Col size='12'>{children}</Col>}
  </Row>
})

